export default __webpack_public_path__ + "static/media/40200.ecb091fe.jpg";